import { connect } from "react-redux";
import PremierProposition from "../../components/PremierProposition/index.jsx";
import { toggleModal } from "../../actions/Modal";
import { addPremierSubscription } from "../../actions/PremierProposition";

const mapStateToProps = (state, { appConfig }) => ({
  appConfig,
  countryData: state.CountrySelector.countryData,
  errorMessage: state.PremierProposition.errorMessage,
  premierDeliveryProposition:
    state.PremierPageFrame.content.premierDeliveryProposition,
  premierSubscriptionAdded: state.PremierProposition.premierSubscriptionAdded,
  assetsUrl: state.Environment.assetsUrl,
  offeredFreeTrial: state.PremierPageFrame.offeredFreeTrial,
  firstName: state.PremierPageFrame.firstName,
  includeFreeTrials: state.PremierPageFrame.includeFreeTrials,
});

const mapDispatchToProps = (dispatch) => ({
  openTermsAndConditions: () => {
    dispatch(toggleModal(true, document.activeElement));
  },
  addPremierSubscription: (subscriptionId) => {
    dispatch(addPremierSubscription(subscriptionId));
  },
});

export default connect(mapStateToProps, mapDispatchToProps)(PremierProposition);
